import React from 'react';

const CommentSection = ({ comments = [] }) => {
    return (
        <div id="comments" className="comments">
            <div className="widget-title">
                <h3>{comments.length < 10 && comments.length > 0 ? `0${comments.length}` : comments.length} {comments.length === 1 ? 'Comment' : 'Comments'}</h3>
            </div>
            <ul className="comment-list">
                {comments.map((val, i) => (
                    <li className="comment" id={`li-comment-${i}`} key={i}>
                        {/* <div className="com-image">
                            <img 
                                src={val.user?.profile_image_url || val.user?.profile_image || val.user?.avatar || 'assets/images/member/02.jpg'} 
                                alt="comments thumb"
                            />
                        </div> */}
                        <div className="com-content">
                            <div className="com-title">
                                <div className="com-title-meta">
                                    <h4><a href="#" rel="external nofollow" className="url">{val.user?.name || "User"}</a></h4>
                                    <span> {new Date(val.created_at).toLocaleString()} </span>
                                </div>
                            </div>
                            <p>{val.comment}</p>
                        </div>
                    </li>
                ))}
                {comments.length === 0 && (
                    <p style={{ marginTop: '20px' }}>No comments yet. Be the first to comment!</p>
                )}
            </ul>
        </div>
    );
};

export default CommentSection;